var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobiledev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 53.586 78.869 c -15.168 0 -27.508 -12.34 -27.508 -27.508 s 12.34 -27.508 27.508 -27.508 c 0.881 0 1.303 0.023 1.643 0.053 l 0.969 -21.281 H 15.329 v 84.881 h 40.868 l -0.969 -8.691 C 54.899 78.858 54.467 78.869 53.586 78.869 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(40,136,168)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.53,
    y: 2.62,
    rx: 0,
    ry: 0,
    width: 17.71,
    height: 4.45,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(71,160,189)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 55.229 78.816 v 6.086 c 0 0.606 -0.493 1.098 -1.098 1.098 H 18.004 c -0.606 0 -1.098 -0.493 -1.098 -1.098 V 4.731 C 16.906 4.328 17.234 4 17.637 4 h 5.689 c 0.379 2.345 2.052 4.126 4.044 4.126 h 17.396 c 1.992 0 3.664 -1.781 4.044 -4.126 h 5.321 c 0.606 0 1.098 0.493 1.098 1.098 v 18.809 c 1.362 0.081 2.698 0.258 4 0.531 V 5.098 C 59.229 2.283 56.946 0 54.131 0 H 17.637 c -2.613 0 -4.731 2.118 -4.731 4.731 v 80.171 c 0 2.816 2.283 5.098 5.098 5.098 h 36.126 c 2.816 0 5.098 -2.283 5.098 -5.098 v -6.617 C 57.927 78.557 56.591 78.735 55.229 78.816 z M 41.948 4.25 c 0.414 0 0.75 0.336 0.75 0.75 c 0 0.414 -0.336 0.75 -0.75 0.75 c -0.414 0 -0.75 -0.336 -0.75 -0.75 C 41.198 4.586 41.534 4.25 41.948 4.25 z M 29.437 4.25 h 9.466 c 0.414 0 0.75 0.336 0.75 0.75 s -0.336 0.75 -0.75 0.75 h -9.466 c -0.414 0 -0.75 -0.336 -0.75 -0.75 S 29.023 4.25 29.437 4.25 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(9,96,125)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.59,
    cy: 51.36,
    r: 21,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(222,254,242)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 53.586 27.853 c -12.983 0 -23.508 10.525 -23.508 23.508 c 0 12.983 10.525 23.508 23.508 23.508 s 23.508 -10.525 23.508 -23.508 C 77.094 38.378 66.569 27.853 53.586 27.853 z M 45.712 54.063 c 0.641 0.525 0.734 1.471 0.209 2.111 c -0.297 0.361 -0.727 0.549 -1.161 0.549 c -0.334 0 -0.671 -0.111 -0.95 -0.34 l -5.175 -4.244 c -0.069 -0.057 -0.128 -0.12 -0.185 -0.185 c -0.008 -0.009 -0.017 -0.015 -0.024 -0.024 c -0.001 -0.001 -0.001 -0.002 -0.002 -0.003 c -0.064 -0.079 -0.12 -0.162 -0.166 -0.25 c -0.007 -0.013 -0.01 -0.027 -0.016 -0.04 c -0.036 -0.075 -0.07 -0.151 -0.093 -0.229 c -0.017 -0.055 -0.023 -0.112 -0.033 -0.169 c -0.007 -0.038 -0.018 -0.076 -0.022 -0.115 c -0.005 -0.054 -0.001 -0.107 0 -0.161 c 0 -0.043 -0.004 -0.085 0 -0.128 c 0.005 -0.052 0.019 -0.102 0.029 -0.153 c 0.009 -0.044 0.013 -0.088 0.026 -0.131 c 0.056 -0.188 0.149 -0.366 0.277 -0.522 c 0 0 0 -0.001 0.001 -0.001 c 0.014 -0.017 0.032 -0.03 0.046 -0.046 c 0.051 -0.057 0.102 -0.113 0.162 -0.163 l 5.175 -4.243 c 0.64 -0.525 1.586 -0.432 2.111 0.209 s 0.432 1.586 -0.209 2.111 l -3.76 3.083 L 45.712 54.063 z M 58.211 45.264 l -6.916 13.558 c -0.265 0.52 -0.791 0.818 -1.337 0.818 c -0.229 0 -0.462 -0.053 -0.681 -0.164 c -0.738 -0.376 -1.031 -1.279 -0.654 -2.018 l 6.916 -13.558 c 0.376 -0.738 1.278 -1.03 2.018 -0.655 C 58.295 43.623 58.588 44.526 58.211 45.264 z M 69.079 51.124 c -0.004 0.037 -0.015 0.073 -0.021 0.11 c -0.01 0.058 -0.017 0.117 -0.034 0.174 c -0.023 0.076 -0.055 0.15 -0.09 0.222 c -0.007 0.016 -0.011 0.032 -0.019 0.047 c -0.046 0.088 -0.102 0.172 -0.167 0.251 c -0.001 0.001 -0.001 0.002 -0.002 0.002 c -0.007 0.008 -0.016 0.014 -0.023 0.022 c -0.057 0.066 -0.117 0.13 -0.186 0.187 l -5.175 4.244 c -0.279 0.229 -0.615 0.34 -0.95 0.34 c -0.434 0 -0.864 -0.188 -1.161 -0.549 c -0.525 -0.641 -0.432 -1.586 0.209 -2.111 l 3.76 -3.084 l -3.76 -3.083 c -0.641 -0.525 -0.734 -1.471 -0.209 -2.111 c 0.526 -0.641 1.471 -0.733 2.111 -0.209 l 5.168 4.237 c 0 0 0.001 0 0.001 0.001 l 0.006 0.005 c 0.045 0.037 0.081 0.081 0.121 0.122 c 0.029 0.03 0.061 0.055 0.088 0.087 c 0.001 0.001 0.001 0.002 0.002 0.002 c 0.064 0.079 0.12 0.163 0.167 0.251 c 0.005 0.01 0.008 0.021 0.013 0.031 c 0.038 0.077 0.072 0.156 0.097 0.238 c 0.017 0.057 0.024 0.116 0.034 0.175 c 0.006 0.037 0.017 0.072 0.021 0.109 c 0.005 0.048 0 0.097 0 0.145 S 69.083 51.076 69.079 51.124 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,176,102)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobiledev);
export default __webpack_public_path__ + "static/media/mobiledev.e5380339bcddb281e3d55dcad3c25929.svg";
export { ForwardRef as ReactComponent };